import { gql } from '@apollo/client';

import { AnswerFragment } from 'approot/activity-builder/present/activity-answers.graphql';

export const UPSERT_STUDENT_ACTIVITY_ANSWER = gql`
  mutation UpsertStudentActivityAnswer(
    $input: UpsertStudentActivityAnswerInput!
  ) {
    upsertStudentActivityAnswer(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;
